// extracted by mini-css-extract-plugin
export default {"mainest":"ContactCSS_mainest__y3v8Q","main":"ContactCSS_main__QIdAL","black":"ContactCSS_black__uYvLy","get_info":"ContactCSS_get_info__N5eQI"};